import React from "react";
import MentorshipWrap from "./MentorshipWrap";

function Mentorship(props) {
    return (
        <>
            <section className="bundles-bg section-bottom-pad"><MentorshipWrap/></section>
        </>
    )
}

export default Mentorship;
